import script from "./ProgramVersionTeamCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramVersionTeamCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramVersionTeamCard.vue?vue&type=style&index=0&id=b4a4e018&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4a4e018"]])

export default __exports__